import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from '@angular/core';
import { FabMenuModel } from './fab-menu/fab-menu.model';
import { Driver, driver } from "driver.js";
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppHeaderComponent } from './header/header.component';
import { AppSidenavComponent } from './sidenav/sidenav.component';
import { AppFooterComponent } from './footer/footer.component';
import { FabMenuComponent } from './fab-menu/fab-menu.component';
import { RightPanelComponent } from './right-panel/right-panel.component';
import { LayoutService } from './layout.service';
import { Subscription, filter } from 'rxjs';
import { CapturaTelaService } from '../modules/captura-tela/service/captura-tela.service';
import { NotificationService } from '../modules/common/service/notification.service';

@Component({
	selector: 'my-app-layout',
	templateUrl: './layout.component.html',
	standalone: true,
	imports: [
		RouterModule,
		CommonModule,
		MatButtonModule,
		MatIconModule,
		MatMenuModule,
		MatTooltipModule,
		AppHeaderComponent,
		AppSidenavComponent,
		AppFooterComponent,
		FabMenuComponent,
		RightPanelComponent
	],
	providers: [
		CapturaTelaService,
		NotificationService
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LayoutComponent implements OnDestroy {

	fabMenuLista: Array<FabMenuModel> = [];

	tourPrincipal: Driver | null = null;
	tourPrincipalIndex: number = 0;

	tourSecundario: Driver | null = null;
	private tourSecundarioAtivo: boolean = false;

	private routerSub: Subscription;

	constructor(
		private router: Router,
		private layoutService: LayoutService,
		private capturaTela: CapturaTelaService
	) {

		this.tourPrincipal = this.configurarTourPrincipal();

		// Monitora navegação para detectar saída da rota /app/template durante o tour secundário
		this.routerSub = this.router.events.pipe(
			filter(event => event instanceof NavigationStart)
		).subscribe((event: NavigationStart) => {
			if (this.tourSecundarioAtivo && !event.url.startsWith('/app/template')) {
				this.finalizarTourSecundarioERetomar();
			}
		});

		this.fabMenuLista = [
			FabMenuModel.fromRaw({ icone: "person", descricao: "menu.novoUsuario", rota: ['/app/usuario/create'] }),
			FabMenuModel.fromRaw({ icone: "storage", descricao: "menu.novaLista", rota: ['/app/lista/create'] }),
			FabMenuModel.fromRaw({ icone: "business", descricao: "menu.novaestrategia", rota: ['/app/estrategia/create'] }),
			FabMenuModel.fromRaw({
				icone: "menu_open", descricao: "menu.painelDireito", action: () => {
					this.layoutService.toggleRightPanel();
				}
			}),
			FabMenuModel.fromRaw({
				icone: "android", descricao: "menu.wizzard", action: () => {
					this.tourPrincipalIndex = 0;
					this.tourPrincipal = this.configurarTourPrincipal();
					this.tourPrincipal.drive();
				}
			})
		];

		this.fabMenuLista.push(
			FabMenuModel.fromRaw({
				icone: 'photo_camera',
				descricao: 'telaCapturaTela.menuSelecionarArea',
				action: () => this.capturaTela.capturarAreaSelecionada()
			})
		);

		this.capturaTela.registrarAtalhoTeclado();
	}

	ngOnDestroy(): void {
		this.routerSub?.unsubscribe();
		this.tourPrincipal?.destroy();
		this.tourSecundario?.destroy();
	}

	private configurarTourPrincipal(): Driver {

		//https://driverjs.com/docs/configuration
		return driver({
			showProgress: true,
			showButtons: ['next', 'previous', 'close'],
			progressText: 'Passo {{current}} de {{total}}',
			nextBtnText: 'Avançar',
			prevBtnText: 'Voltar',
			doneBtnText: 'Vamos lá',
			onNextClick: () => {
				const activeIndex = this.tourPrincipal!.getActiveIndex();
				const routeByStep: Record<number, string> = {
					0: "/app/carteira",
					1: "/app/template",
					3: "/app/lista",
					4: "/app/jornada",
					5: "/app/tarefa",
					6: "/app/filtroquery",
					7: "/app/ordenacaopadrao",
					8: "/app/rotina"
				};

				this.tourPrincipalIndex = activeIndex;

				const nextRoute = routeByStep[activeIndex];

				if (nextRoute) {
					this.router.navigate([nextRoute]);
					setTimeout(() => this.tourPrincipal!.moveNext(), 220);
					return;
				}

				this.tourPrincipal!.moveNext();
			},
			onPopoverRender: (popover, { config, state }) => {
				// No step 2 (Template), adiciona botão para iniciar tour secundário
				if (this.tourPrincipalIndex == 1) {
					const firstButton = document.createElement("button");
					firstButton.innerText = "Filtrar template";
					popover.footerButtons.appendChild(firstButton);

					firstButton.addEventListener("click", () => {
						this.iniciarTourSecundario();
					});
				}
			},
			steps: [
				{ element: '#Provedor', popover: { title: 'Provedor', description: 'Nesse menu você cadastra seus Brokers/Provedores para fazer envios de suas Jornadas/Estrategias.', side: "left", align: 'start' } },
				{ element: '#Carteira', popover: { title: 'Carteira', description: 'Nesse menu você cadastra sua Carteira definir permissõess de acesso para cada Usuario de acordo com a regra de acesso definida.', side: "left", align: 'start' } },
				{ element: '#Template', popover: { title: 'Template', description: 'Nesse menu você cadastra um template de importacao e difini o tipo de dados que será importado.', side: "left", align: 'start' } },
				{ element: '#Template', popover: { title: 'Template de Exportacao', description: 'Nele voce cria e associa o provedor que deseja enviar sua estrategia.', side: "left", align: 'start' } },
				{ element: '#Lista', popover: { title: 'Lista', description: 'Nesse menu você cria a sua Lista e insere registros via API/Arquivo/FTP entre outras integracoes.', side: "left", align: 'start' } },
				{ element: '#Jornada', popover: { title: 'Jornada', description: 'Nesse menu Jornada é onde podemos fazer criacao das Estrategias, criacao dos seus Widgets e regra de envios que você precisa.', side: "left", align: 'start' } },
				{ element: '#ExecucaoEstrategia', popover: { title: 'Execucao de estrategia', description: 'Nesse menu você	 consegue acompanhar suas Estrategias agendadas, histórico de execucões entre outras funcionalidades.', side: "left", align: 'start' } },
				{ element: '#FiltroPadrao', popover: { title: 'Filtro Padrao', description: 'Nesse menu voce consegue definir Filtro especifico e associar esse filtro a varias Estrategias.', side: "left", align: 'start' } },
				{ element: '#OrdenacaoPadrao', popover: { title: 'Ordenacao Padrao', description: 'Nesse menu você consegue definir uma ordem de ordenacao na hora do envio e tambem associar esse Filtro a varias Estrategias.', side: "left", align: 'start' } },
				{ element: '#Rotina', popover: { title: 'Rotina', description: 'Nesse menu voce consegue criar uma Rotian de copiar ou excluir logicamente um dado de uma lista para outro.', side: "left", align: 'start' } },
			]
		});
	}

	private iniciarTourSecundario(): void {
		// Salva o índice atual do tour principal antes de destruir
		this.tourPrincipalIndex = this.tourPrincipal!.getActiveIndex()!;

		// Destroi o tour principal para liberar o overlay
		this.tourPrincipal!.destroy();
		this.tourPrincipal = null;

		// Cria e inicia o tour secundário
		this.tourSecundarioAtivo = true;
		this.tourSecundario = this.criarTourSecundarioTemplate();

		setTimeout(() => {
			this.tourSecundario!.drive();
		}, 250);
	}

	private finalizarTourSecundarioERetomar(): void {
		if (!this.tourSecundarioAtivo) return;

		this.tourSecundarioAtivo = false;

		if (this.tourSecundario) {
			this.tourSecundario.destroy();
			this.tourSecundario = null;
		}

		// Recria e retoma o tour principal no step onde parou
		this.tourPrincipal = this.configurarTourPrincipal();

		setTimeout(() => {
			this.tourPrincipal!.drive(this.tourPrincipalIndex);
		}, 300);
	}

	private criarTourSecundarioTemplate(): Driver {
		return driver({
			showProgress: true,
			showButtons: ['next', 'previous', 'close'],
			progressText: 'Passo {{current}} de {{total}}',
			nextBtnText: 'Avançar',
			prevBtnText: 'Voltar',
			doneBtnText: 'Voltar ao tour',
			onDestroyStarted: () => {
				// Quando o tour secundário é fechado pelo usuário (close ou done),
				// retoma o tour principal
				if (this.tourSecundarioAtivo) {
					this.tourSecundarioAtivo = false;
					this.tourSecundario!.destroy();
					this.tourSecundario = null;

					// Recria e retoma o tour principal no step onde parou
					this.tourPrincipal = this.configurarTourPrincipal();
					setTimeout(() => {
						this.tourPrincipal!.drive(this.tourPrincipalIndex);
					}, 300);
				}
			},
			steps: [
				{ element: '#txt-filtro-listaTemplateId', popover: { title: 'Template ID', description: 'Nesse campo você filtra pelo ID do template para encontrar rapidamente.', side: "left", align: 'start' } },
				{ element: '#txt-filtro-nome', popover: { title: 'Nome do Template', description: 'Nesse campo você filtra pelo nome do template.', side: "left", align: 'start' } },
				{ element: '#btn-filtro-pesquisar', popover: { title: 'Pesquisar', description: 'Clique aqui para aplicar os filtros e pesquisar os templates.', side: "left", align: 'start' } },
			]
		});
	}
}
